(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("babel-runtime/helpers/extends"), require("lodash"), require("vuex"), require("babel-runtime/core-js/json/stringify"), require("babel-runtime/core-js/object/assign"), require("babel-runtime/helpers/defineProperty"), require("clone"), require("tinycolor2"), require("vue"), require("vue-color"), require("vue-dialog-drag"));
	else if(typeof define === 'function' && define.amd)
		define(["babel-runtime/helpers/extends", "lodash", "vuex", "babel-runtime/core-js/json/stringify", "babel-runtime/core-js/object/assign", "babel-runtime/helpers/defineProperty", "clone", "tinycolor2", "vue", "vue-color", "vue-dialog-drag"], factory);
	else if(typeof exports === 'object')
		exports["gotu-vue-dycolor"] = factory(require("babel-runtime/helpers/extends"), require("lodash"), require("vuex"), require("babel-runtime/core-js/json/stringify"), require("babel-runtime/core-js/object/assign"), require("babel-runtime/helpers/defineProperty"), require("clone"), require("tinycolor2"), require("vue"), require("vue-color"), require("vue-dialog-drag"));
	else
		root["gotu-vue-dycolor"] = factory(root["babel-runtime/helpers/extends"], root["lodash"], root["vuex"], root["babel-runtime/core-js/json/stringify"], root["babel-runtime/core-js/object/assign"], root["babel-runtime/helpers/defineProperty"], root["clone"], root["tinycolor2"], root["vue"], root["vue-color"], root["vue-dialog-drag"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_20__, __WEBPACK_EXTERNAL_MODULE_21__, __WEBPACK_EXTERNAL_MODULE_22__, __WEBPACK_EXTERNAL_MODULE_23__, __WEBPACK_EXTERNAL_MODULE_24__, __WEBPACK_EXTERNAL_MODULE_25__, __WEBPACK_EXTERNAL_MODULE_26__, __WEBPACK_EXTERNAL_MODULE_27__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/gotu-vue-dycolor/dist";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 12);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */,
/* 1 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("babel-runtime/helpers/extends");

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = require("lodash");

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = require("vuex");

/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);




var _mutations;




var UPDATE_CLIENT_COLORS = 'UPDATE_CLIENT_COLORS';
var UPDATE_COMPONENT_CSS = 'UPDATE_COMPONENT_CSS';
var UPDATE_COMPILED_CSS = 'UPDATE_COMPILED_CSS';
var UPDATE_COMPONENT_COLORS = 'UPDATE_COMPONENT_COLORS';
var SET_ACTIVE_COLOR = 'SET_ACTIVE_COLOR';
var UPDATE_COLOR = 'UPDATE_COLOR';
var REMOVE_COLOR = 'REMOVE_COLOR';
var REMOVE_ALL_COLORS = 'REMOVE_ALL_COLORS';
var UPDATE_FINAL_COLORS = 'UPDATE_FINAL_COLORS';

var getters = {
  defaultColors: function defaultColors(state) {
    var colors = [];
    __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.forOwn(state.defaultColors, function (value, key) {
      colors.push({ name: key, color: value });
    });
    return colors;
  },
  getCompiledJson: function getCompiledJson(state) {
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(state.compiledJson);
  }
};

var actions = {
  updateClientColors: function updateClientColors(_ref, colors) {
    var commit = _ref.commit;

    commit(UPDATE_CLIENT_COLORS, { colors: colors });
    commit(UPDATE_FINAL_COLORS);
    commit(UPDATE_COMPILED_CSS);
  },
  updateComponentCss: function updateComponentCss(_ref2, component) {
    var commit = _ref2.commit;

    commit(UPDATE_COMPONENT_CSS, { component: component });
    commit(UPDATE_FINAL_COLORS);
    commit(UPDATE_COMPILED_CSS);
  },
  updateComponent: function updateComponent(_ref3, component) {
    var commit = _ref3.commit;

    commit(UPDATE_COMPONENT_COLORS, { component: component });
    commit(UPDATE_FINAL_COLORS);
  },
  setActiveColor: function setActiveColor(_ref4, name) {
    var commit = _ref4.commit;

    commit(SET_ACTIVE_COLOR, { name: name });
    commit(UPDATE_FINAL_COLORS);
  },
  updateOverwrittenColor: function updateOverwrittenColor(_ref5, data) {
    var commit = _ref5.commit;

    commit(UPDATE_COLOR, { data: data });
    commit(UPDATE_FINAL_COLORS);
    commit(UPDATE_COMPILED_CSS);
  },
  deleteOverwrittenColor: function deleteOverwrittenColor(_ref6, data) {
    var commit = _ref6.commit;

    commit(REMOVE_COLOR, { data: data });
    commit(UPDATE_FINAL_COLORS);
    commit(UPDATE_COMPILED_CSS);
  },
  resetAllColors: function resetAllColors(_ref7) {
    var commit = _ref7.commit;

    commit(REMOVE_ALL_COLORS);
    commit(UPDATE_FINAL_COLORS);
    commit(UPDATE_COMPILED_CSS);
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, UPDATE_CLIENT_COLORS, function (state, _ref8) {
  var colors = _ref8.colors;

  state.clientColors = colors;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, UPDATE_COMPONENT_CSS, function (state, _ref9) {
  var component = _ref9.component;

  __WEBPACK_IMPORTED_MODULE_3_vue___default.a.set(state.componentCss, component.name, component.css);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, UPDATE_COMPILED_CSS, function (state) {
  var compiledCss = '';
  __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.forOwn(state.componentCss, function (css, key) {
    var componentColors = {};
    var replacedCss = css.replace(/\bdycolor-internal\((.*?)\)/g, function (res, group) {
      return group.split(',').reduce(function (acc, color) {
        var trimmedName = color.trim();
        var name = trimmedName.substr(1);
        if (trimmedName.startsWith('!')) {
          componentColors[name] = null;
          name = '' + key + trimmedName;
        }
        // Return first found color
        if (acc) return acc;
        return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.has(state.finalColors, name) && acc === null ? state.finalColors[name] : null;
      }, null);
    });
    __WEBPACK_IMPORTED_MODULE_3_vue___default.a.set(state.componentColors, key, componentColors);
    compiledCss += replacedCss;
  });
  state.compiledCss = compiledCss;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, UPDATE_COMPONENT_COLORS, function (state, _ref10) {
  var component = _ref10.component;

  __WEBPACK_IMPORTED_MODULE_3_vue___default.a.set(state.componentColors, component.name, component.colors);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, SET_ACTIVE_COLOR, function (state, _ref11) {
  var name = _ref11.name;

  state.activeColor = name;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, UPDATE_COLOR, function (state, _ref12) {
  var data = _ref12.data;

  var colorName = data.component ? data.component + '!' + state.activeColor : state.activeColor;
  __WEBPACK_IMPORTED_MODULE_3_vue___default.a.set(state.overwrittenColors, colorName, data.color);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, REMOVE_COLOR, function (state, _ref13) {
  var data = _ref13.data;

  var colorName = data.component ? data.component + '!' + data.name : data.name;
  __WEBPACK_IMPORTED_MODULE_3_vue___default.a.delete(state.overwrittenColors, colorName);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, REMOVE_ALL_COLORS, function (state) {
  state.overwrittenColors = {};
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, UPDATE_FINAL_COLORS, function (state) {
  state.finalColors = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, state.defaultColors, state.clientColors, state.overwrittenColors);

  var jsonColors = {};
  __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.forOwn(state.overwrittenColors, function (value, key) {
    jsonColors[key] = value;
  });

  state.compiledJson = jsonColors;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (function (defaultColors) {
  return {
    namespaced: true,
    state: {
      defaultColors: defaultColors,
      activeColor: null, // Selected (active) color from ColorPicker component
      componentColors: {}, // Component specific colors
      clientColors: {}, // Colors from client (API/database)
      overwrittenColors: {}, // Temporary overwritten colors by ColorPicker component
      finalColors: {}, // Computed colors from default, component and overwritten colors
      componentCss: {}, // Stores css for each component
      compiledCss: '', // Compiled css which is injected in head
      compiledJson: {} // JSON colors for copying style to dashboard
    },
    getters: getters,
    actions: actions,
    mutations: mutations
  };
});

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(17)
  this["$style"] = __webpack_require__(16)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(14),
  /* template */
  __webpack_require__(18),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(15),
  /* template */
  __webpack_require__(19),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "requireString", function() { return requireString; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_node__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_node___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_node__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "node", function() { return __WEBPACK_IMPORTED_MODULE_0__components_node___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_editor__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_editor__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "editor", function() { return __WEBPACK_IMPORTED_MODULE_1__components_editor___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(6);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "store", function() { return __WEBPACK_IMPORTED_MODULE_2__store__["a"]; });




// export { default as loader } from './loader';



var requireString = ['!', '!', 'css-loader', '?modules=true', '!', 'dycolor-loader', '?colors', '!', 'sass-loader', '?outputStyle=compressed', '!'].join('');

/***/ }),
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clone__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_clone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tinycolor2__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tinycolor2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_tinycolor2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_color__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_color__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_dialog_drag__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_dialog_drag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_dialog_drag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuex__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var white = '#ffffff';
var black = '#000000';

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'chrome-picker': __WEBPACK_IMPORTED_MODULE_4_vue_color__["Chrome"],
    'dialog-drag': __WEBPACK_IMPORTED_MODULE_5_vue_dialog_drag___default.a
  },
  data: function data() {
    return {
      hideColorPicker: true,
      defaultColor: white,
      activeComponent: null,
      primary: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["mapGetters"])('dycolor', ['defaultColors', 'getCompiledJson']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["mapState"])('dycolor', ['componentColors', 'overwrittenColors', 'finalColors', 'compiledCss']), {
    activeComponentColors: function activeComponentColors() {
      var colors = [];
      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forOwn(this.componentColors[this.activeComponent], function (value, key) {
        var color = value || white;
        colors.push({ name: key, color: color });
      });
      return colors;
    },
    componentColorsClone: function componentColorsClone() {
      return __WEBPACK_IMPORTED_MODULE_2_clone___default()(this.componentColors);
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["mapActions"])('dycolor', ['setActiveColor', 'resetAllColors', 'updateComponent', 'updateOverwrittenColor', 'deleteOverwrittenColor']), {
    getSpinColor: function getSpinColor(color) {
      return __WEBPACK_IMPORTED_MODULE_3_tinycolor2___default.a.mostReadable(color, [black, white]).toHexString();
    },
    getColorStyle: function getColorStyle(name) {
      var background = this.finalColors[name] ? this.finalColors[name] : 'repeating-linear-gradient(-45deg, #ccc, #ccc 10px, #dbdbdb 10px, #dbdbdb 20px)';
      var color = this.finalColors[name] ? this.getSpinColor(this.finalColors[name]) : black;
      return { background: background, color: color };
    },
    hideResetButton: function hideResetButton(name) {
      return !__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.has(this.overwrittenColors, name);
    },
    updateColors: function updateColors(color) {
      var component = this.primary ? null : this.activeComponent;
      this.updateOverwrittenColor({ component: component, color: color.hex });
    },
    resetColor: function resetColor(name) {
      var primary = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var component = primary ? null : this.activeComponent;
      this.deleteOverwrittenColor({ component: component, name: name });
    },
    openColorPicker: function openColorPicker(name, e) {
      var primary = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      this.primary = primary;
      this.setActiveColor(name);
      this.defaultColor = this.finalColors[name] || white;
      this.$refs.colorPicker.$el.style.left = e.target.parentNode.offsetLeft + e.offsetX + 10 + 'px';
      this.$refs.colorPicker.$el.style.top = e.target.parentNode.offsetTop + e.offsetY + 10 + 'px';
      if (this.hideColorPicker) {
        document.addEventListener('click', this.hide);
        this.hideColorPicker = false;
      }
    },
    hide: function hide(e) {
      var found = false;
      e.path.forEach(function (path) {
        if (path.className === 'vc-chrome' || path.className === 'color-block') {
          found = true;
        }
      });
      if (!found) {
        this.hideColorPicker = true;
        document.removeEventListener('click', this.hide);
        this.setActiveColor(null);
      }
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.$refs.modal.$on('close', function () {
      _this.$emit('close');
    });
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex__);

//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      styleNode: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapState"])('dycolor', ['compiledCss'])),
  methods: {
    createStyleNode: function createStyleNode(css) {
      var newNode = document.createElement('style');
      newNode.type = 'text/css';
      newNode.id = 'dycolor-injected-style';
      if (newNode.styleSheet) {
        newNode.styleSheet.cssText = css;
      } else {
        newNode.appendChild(document.createTextNode(css));
      }
      return newNode;
    },
    replaceStyleNode: function replaceStyleNode() {
      var newNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (newNode) {
        document.querySelector('head').appendChild(newNode);
      }

      if (this.styleNode) {
        this.styleNode.parentNode.removeChild(this.styleNode);
      }

      this.styleNode = newNode;
    }
  },
  watch: {
    compiledCss: {
      immediate: true,
      handler: function handler(css) {
        this.replaceStyleNode(this.createStyleNode(css));
      }
    }
  }
});

/***/ }),
/* 16 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"vLBV05FIzbxkidNHH2dpk_1"};

/***/ }),
/* 17 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('dialog-drag', {
    ref: "modal",
    attrs: {
      "options": {
        right: 0,
        buttonPin: false,
        buttonClose: true
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Color Picker")]), _c('chrome-picker', {
    ref: "colorPicker",
    class: {
      "d-none": _vm.hideColorPicker
    },
    attrs: {
      "value": _vm.defaultColor
    },
    on: {
      "input": _vm.updateColors
    }
  }), _c('ul', {
    staticClass: "color-list"
  }, _vm._l((_vm.defaultColors), function(item) {
    return _c('li', {
      class: {
        "hide-reset": _vm.hideResetButton(item.name)
      },
      style: (_vm.getColorStyle(item.name))
    }, [_vm._v(_vm._s(item.name)), _c('div', {
      staticClass: "color-block",
      on: {
        "click": function($event) {
          _vm.openColorPicker(item.name, $event, true)
        }
      }
    }), _c('b-btn', {
      staticClass: "close",
      on: {
        "click": function($event) {
          _vm.resetColor(item.name, true)
        }
      }
    }, [_vm._v("x")])], 1)
  })), _c('b-form-select', {
    staticClass: "mt-2",
    attrs: {
      "options": _vm.componentColorsClone
    },
    model: {
      value: (_vm.activeComponent),
      callback: function($$v) {
        _vm.activeComponent = $$v
      },
      expression: "activeComponent"
    }
  }, [_c('template', {
    slot: "first"
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("None")])])], 2), _c('ul', {
    staticClass: "color-list mt-2"
  }, _vm._l((_vm.activeComponentColors), function(item) {
    return _c('li', {
      class: {
        "hide-reset": _vm.hideResetButton((_vm.activeComponent + "!" + (item.name)))
      },
      style: (_vm.getColorStyle((_vm.activeComponent + "!" + (item.name))))
    }, [_vm._v(_vm._s(item.name)), _c('div', {
      staticClass: "color-block",
      on: {
        "click": function($event) {
          _vm.openColorPicker(item.name, $event)
        }
      }
    }), _c('b-btn', {
      staticClass: "close",
      on: {
        "click": function($event) {
          _vm.resetColor(item.name)
        }
      }
    }, [_vm._v("x")])], 1)
  })), _c('div', {
    staticClass: "row mt-4"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('b-form-input', {
    attrs: {
      "value": _vm.getCompiledJson
    }
  })], 1), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-btn', {
    staticClass: "d-block",
    on: {
      "click": _vm.resetAllColors
    }
  }, [_vm._v("reset all")])], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gotu-dycolor-node",
    staticStyle: {
      "display": "none"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = require("babel-runtime/core-js/json/stringify");

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = require("babel-runtime/core-js/object/assign");

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = require("babel-runtime/helpers/defineProperty");

/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = require("clone");

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = require("tinycolor2");

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = require("vue");

/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports = require("vue-color");

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = require("vue-dialog-drag");

/***/ })
/******/ ]);
});
//# sourceMappingURL=gotu-vue-dycolor.js.map


//////////////////
// WEBPACK FOOTER
// ./~/gotu-vue-dycolor/dist/lib/gotu-vue-dycolor.js
// module id = 298
// module chunks = 0